import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKodemMcp = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 54,
	height: 54,
	viewBox: "0 0 54 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.56966 53.9949C2.94733 53.9949 0 51.0475 0 47.4252V6.56966C0 2.94733 2.94733 0 6.56966 0H47.4303C51.0527 0 54 2.94733 54 6.56966V47.4303C54 51.0527 51.0527 54 47.4303 54H6.56966V53.9949ZM6.56966 4.96202C5.6834 4.96202 4.96718 5.6834 4.96718 6.5645V47.4252C4.96718 48.3115 5.68855 49.0277 6.56966 49.0277H47.4303C48.3166 49.0277 49.0328 48.3063 49.0328 47.4252V6.56966C49.0328 5.6834 48.3115 4.96718 47.4303 4.96718H6.56966V4.96202Z",
			fill: "url(#paint0_linear_117176_172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6324 8C31.3894 8.00004 33.0818 8.64184 34.3948 9.79731L34.6525 10.0356L34.6533 10.0364C35.4311 10.7955 36.0188 11.7279 36.3678 12.7573C36.6581 13.6139 36.7733 14.5174 36.7151 15.4166C37.627 15.3582 38.5433 15.4715 39.4149 15.7562C40.4557 16.0963 41.4051 16.6693 42.1916 17.431L42.2735 17.5062L42.2786 17.5105L42.2828 17.5147C42.9418 18.1572 43.4658 18.9256 43.8233 19.7734C44.1808 20.6213 44.3649 21.5326 44.3649 22.4529C44.3649 23.373 44.1807 24.2838 43.8233 25.1315C43.466 25.9787 42.942 26.7455 42.2837 27.3877L42.2845 27.3885L28.6361 40.7851L28.6344 40.7902C28.6344 40.7922 28.6353 40.7944 28.6353 40.7944L31.4347 43.5373L31.5513 43.6632C31.662 43.7953 31.7523 43.9432 31.8192 44.1018C31.9086 44.3139 31.9544 44.5418 31.9544 44.7718C31.9544 45.0018 31.9087 45.2297 31.8192 45.4419C31.7301 45.6533 31.5999 45.8461 31.4347 46.0072L31.433 46.0081C31.0998 46.3297 30.654 46.5099 30.1909 46.51C29.7276 46.51 29.282 46.3297 28.9487 46.0081L28.9471 46.0072L26.1298 43.2593C25.8005 42.9386 25.5381 42.5539 25.3592 42.1304C25.1803 41.7065 25.0879 41.2505 25.0879 40.7902C25.088 40.3299 25.1804 39.8745 25.3592 39.4509C25.5382 39.0268 25.8009 38.6429 26.1307 38.322L39.7901 24.9262C40.1176 24.6046 40.3779 24.2207 40.5557 23.7973C40.7113 23.4266 40.801 23.0317 40.821 22.6312L40.8252 22.4588C40.8252 21.9993 40.7335 21.5441 40.5557 21.1203C40.3778 20.6966 40.117 20.3123 39.7892 19.9905L39.7183 19.9255L39.7132 19.9213L39.709 19.917C39.0329 19.2598 38.1269 18.8914 37.1841 18.8904C36.2415 18.8894 35.335 19.2562 34.6576 19.912L23.4089 30.9409L23.2509 31.0989C22.9173 31.4227 22.4703 31.6042 22.0054 31.6042C21.5988 31.6042 21.2057 31.4656 20.89 31.2138L20.759 31.0989C20.6349 30.9779 20.53 30.8391 20.4481 30.6882L20.3737 30.5336C20.2846 30.3223 20.2376 30.0939 20.2376 29.8627C20.2377 29.6314 20.2847 29.4035 20.3737 29.1926C20.4628 28.9813 20.5937 28.7885 20.759 28.6273L32.1724 17.4403C32.4986 17.1185 32.758 16.735 32.9346 16.3123C33.1113 15.8893 33.2013 15.4345 33.2008 14.9755C33.2002 14.5163 33.1089 14.0613 32.9312 13.6387C32.7538 13.2169 32.4935 12.8345 32.1665 12.5131C31.4894 11.8549 30.5824 11.4865 29.6383 11.4865C28.6942 11.4865 27.7871 11.855 27.11 12.5131L12.0074 27.3201L12.0057 27.3218C11.6727 27.6431 11.2277 27.8236 10.7644 27.8237C10.3011 27.8237 9.85546 27.6434 9.52221 27.3218L9.52136 27.3209C9.35679 27.1604 9.2248 26.9681 9.1352 26.7556C9.04583 26.5435 9 26.3156 9 26.0855C9 25.8555 9.04581 25.6276 9.1352 25.4154C9.2248 25.2029 9.35677 25.0106 9.52136 24.8501L24.6105 10.0373L24.6122 10.0356C25.9573 8.73068 27.7581 8 29.6324 8Z",
			fill: "url(#paint1_linear_117176_172)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.6383 13.2407C30.0437 13.2407 30.4355 13.3786 30.7503 13.6285L30.8804 13.7426L30.8813 13.7435C31.0459 13.9039 31.1778 14.0963 31.2674 14.3088C31.3571 14.5213 31.4026 14.7499 31.4026 14.9797C31.4025 15.2094 31.3569 15.4375 31.2674 15.6498C31.1779 15.862 31.0456 16.053 30.8813 16.2134L30.8821 16.2142L19.707 27.1637C19.3794 27.4854 19.1192 27.8691 18.9414 28.2927C18.7635 28.7165 18.6719 29.1717 18.6719 29.6311C18.6719 30.0903 18.7636 30.545 18.9414 30.9688C19.119 31.3919 19.379 31.7754 19.7061 32.0968L19.8354 32.2168C20.4965 32.7998 21.3492 33.1235 22.2344 33.1235C23.1785 33.1235 24.0855 32.755 24.7626 32.0968L35.931 21.149L36.0611 21.0333C36.3771 20.7794 36.7718 20.6395 37.1807 20.6395C37.6476 20.6395 38.0957 20.8221 38.4296 21.1482C38.5942 21.3086 38.7262 21.501 38.8158 21.7135C38.9051 21.9255 38.951 22.1535 38.951 22.3836C38.951 22.6136 38.9052 22.8415 38.8158 23.0537C38.7263 23.2659 38.594 23.4569 38.4296 23.6173L38.4305 23.6181L27.2613 34.5676L27.2596 34.5693C25.9145 35.8739 24.1143 36.6041 22.2403 36.6041C20.4833 36.604 18.7909 35.9622 17.4779 34.8068L17.2202 34.5685C16.5612 33.926 16.0372 33.1576 15.6797 32.3098C15.3223 31.462 15.1381 30.5513 15.1381 29.6311C15.1381 28.7109 15.3222 27.7996 15.6797 26.9516C16.0372 26.1038 16.5612 25.3355 17.2202 24.693L28.3944 13.7443L28.3961 13.7426C28.7293 13.421 29.1752 13.2408 29.6383 13.2407Z",
			fill: "url(#paint2_linear_117176_172)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_117176_172",
				x1: 6.5,
				y1: 13.5,
				x2: 47,
				y2: 37.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_117176_172",
				x1: 13.2569,
				y1: 17.6275,
				x2: 40.9064,
				y2: 32.6743,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_117176_172",
				x1: 13.2569,
				y1: 17.6275,
				x2: 40.9064,
				y2: 32.6743,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .100856,
					stopColor: "#FF6868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FEB45E"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgKodemMcp);
export { ForwardRef as ReactComponent };
